module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n      Billing Information\n    ")]), _vm._v(" "), (_vm.filteredItems) ? _c('v-card-text', {
    staticClass: "noprint"
  }, [_vm._v("\n      Total Orgs: " + _vm._s(_vm.filteredItems.length) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "mx-3 noprint",
    attrs: {
      "label": "filters"
    }
  }, [_c('span', {
    staticClass: "ml-1 mr-3 my-8"
  }, [_vm._v("Filters:")]), _vm._v(" "), _vm._l((_vm.filters), function(filter, i) {
    return _c('v-col', {
      key: i,
      staticClass: "mx-2",
      attrs: {
        "cols": "1"
      }
    }, [_c('v-checkbox', {
      attrs: {
        "label": filter.text
      },
      on: {
        "click": _vm.filterItems
      },
      model: {
        value: (filter.value),
        callback: function($$v) {
          _vm.$set(filter, "value", $$v)
        },
        expression: "filter.value"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-dataTable', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredItems,
      "items-per-page": 25,
      "footer-props": {
        'items-per-page-options': [10, 25, 100, -1]
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b3dfb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Billing.vue
// module id = 400
// module chunks = 1